// cms module Text hat eine auf und zuklapp funktion
export class TextModuleToggler {
    private readMoreButtons: NodeListOf<Element>;
    private readLessButtons: NodeListOf<Element>;

    constructor(content: Element = document.documentElement) {
        this.readMoreButtons = content.querySelectorAll('.cms-textmodule .read_more');
        this.readLessButtons = content.querySelectorAll('.cms-textmodule .read_less');
        this.initEventListeners();
    }

    private initEventListeners(): void {
        this.readMoreButtons.forEach((button: Element) => {
            button.addEventListener('click', this.handleReadMoreClick.bind(this));
        });

        this.readLessButtons.forEach((button: Element) => {
            button.addEventListener('click', this.handleReadLessClick.bind(this));
        });
    }

    private handleReadMoreClick(event: Event): void {
        event.preventDefault();
        const button = event.currentTarget as HTMLElement;
        button.classList.add('hidden');
        const parentDiv = button.closest('div') as HTMLElement;
        parentDiv.querySelector('.read_less')?.classList.remove('hidden');
        parentDiv.querySelector('.text-hidden')?.classList.remove('hidden');
    }

    private handleReadLessClick(event: Event): void {
        event.preventDefault();
        const button = event.currentTarget as HTMLElement;
        button.classList.add('hidden');
        const parentDiv = button.closest('div') as HTMLElement;
        parentDiv.querySelector('.read_more')?.classList.remove('hidden');
        parentDiv.querySelector('.text-hidden')?.classList.add('hidden');
    }
}

